/**
 * Broad sanity envelope for coordinates crossing persistence or network
 * boundaries. This is not an authored map-size limit: active map systems and
 * authoritative handlers still enforce the real bounds and gameplay rules.
 */
export const WORLD_COORDINATE_ENVELOPE_PX = 1_000_000;
